var React = require('react');

function Bath (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.7498 20.8333H14.5832V14.5833C14.5832 12.2854 16.4519 10.4167 18.7498 10.4167C21.0478 10.4167 22.9165 12.2854 22.9165 14.5833H27.0832C27.0832 9.9875 23.3457 6.25 18.7498 6.25C14.154 6.25 10.4165 9.9875 10.4165 14.5833V20.8333H6.24984C5.6973 20.8333 5.1674 21.0528 4.7767 21.4435C4.386 21.8342 4.1665 22.3641 4.1665 22.9167V27.0833C4.1665 32.5125 7.654 37.1313 12.4998 38.8542V45.8333H16.6665V39.5833H33.3332V45.8333H37.4998V38.8542C42.3457 37.1313 45.8332 32.5125 45.8332 27.0833V22.9167C45.8332 22.3641 45.6137 21.8342 45.223 21.4435C44.8323 21.0528 44.3024 20.8333 43.7498 20.8333ZM41.6665 27.0833C41.6665 31.6792 37.929 35.4167 33.3332 35.4167H16.6665C12.0707 35.4167 8.33317 31.6792 8.33317 27.0833V25H41.6665V27.0833Z","fill":"#8F9F84"}));
}

Bath.defaultProps = {"width":"50","height":"50","viewBox":"0 0 50 50","fill":"none"};

module.exports = Bath;

Bath.default = Bath;
